/**
 * Global Middleware: Block Agents from Integrations (QC-25155)
 *
 * Agents/members never get access to Integrations, but individual integration
 * sub-pages only check settings_integrations_view, so an agent could reach
 * them by typing the URL directly. Mirrors hub-chat's
 * block-agent-integrations.global.ts for the integration pages still served
 * by this repo. Registered globally so new integration pages are covered
 * automatically.
 */

const AGENT_ROLES = ['agent', 'member']

const isUnderPath = (path, prefix) =>
  path === prefix || path.startsWith(`${prefix}/`)

export default function blockAgentIntegrations({ route, $auth, redirect }) {
  if (!isUnderPath(route.path, '/integrations')) return

  if (AGENT_ROLES.includes($auth.user?.role)) {
    return redirect('/404')
  }
}
